<ft-sections #ftSecsTop [registry]="[{name: 'guests', isActive: true}, {name: 'visitors', isActive: false}, {name: 'wedding', isActive: false}, {name: 'fans', isActive: false}, {name: 'team', isActive: false}]"
             (afterInit)="onSectionsInitialized($event.controller)">
    <section class="ft-master-section ft-audiences-master">
        <nav class="ft-nav ft-segments-nav advocacy-audiences">
            <ul>
                <li [ngClass]="{'active': ftSecsTop.isSectionActive('guests')}">
                    <a class="ft-segment-guests" ftSectionTrigger="guests" (click)="changeSection('guestsAndFriends')">
                        <span class="ft-content" translate="flipto.account.GuestsAndFriends"></span>
                    </a>
                </li>

                <li [ngClass]="{'active': ftSecsTop.isSectionActive('visitors')}">
                    <a class="ft-segment-visitors" ftSectionTrigger="visitors" (click)="changeSection('visitors')">
                        <span class="ft-content" translate="flipto.account.WebsiteVisitors"></span>
                    </a>
                </li>

                <li [ngClass]="{'active': ftSecsTop.isSectionActive('fans')}">
                    <a class="ft-segment-fans" ftSectionTrigger="fans" (click)="getFansAndFollowersData()">
                        <span class="ft-content" translate="flipto.account.FansAndFollowers"></span>
                    </a>
                </li>

                <li [ngClass]="{'active': ftSecsTop.isSectionActive('wedding')}">
                    <a class="ft-segment-wedding" ftSectionTrigger="wedding" (click)="changeSection('weddings')">
                        <span class="ft-content" translate="flipto.account.Wedding"></span>
                    </a>
                </li>

                <li [ngClass]="{'active': ftSecsTop.isSectionActive('team')}">
                    <a class="ft-segment-team" ftSectionTrigger="team" (click)="changeSection('team')">
                        <span class="ft-content" translate="flipto.account.Team"></span>
                    </a>
                </li>
            </ul>
        </nav>

        <ft-initialized-content [isInitialized]="isInitialized">
            <ft-section name="guests">
                <div class="ft-view ft-segment-guests">
                    <!--<section class="ft-section ft-synopsis-section">
                        <div class="ft-container">
                            <div class="ft-section-image"></div>
                            <div class="ft-content">
                                Let your
                                <span class="ft-persona-scheme-guests">guests</span> introduce your hotel with captivating
                                stories that inspire
                                <span class="ft-persona-scheme-friends">friends & family</span> to take interest in a future
                                stay.
                            </div>
                        </div>
                    </section>-->

                    <section class="ft-section">
                        <div class="ft-container">
                            <div class="ft-section-header">
                                <div class="ft-heading ft-text-plus-3">{{'flipto.account.AfterYourGuestsStay' | translate }}</div>
                            </div>
                        </div>

                        <ft-expandable-content class="ft-storytellers-expandable" [ngClass]="{'is-off': !photoAdvocacy?.isActive}" (afterCollapsed)="resetSection('GeneralContests')">
                            <collapsed>
                                <div class="ft-heading ft-anim ft-text-plus-2">
                                    {{'flipto.account.TurnGuestsIntoPowerfulStorytellers' | translate }}
                                </div>
                                <div class="ft-summary ft-anim">
                                    {{'flipto.account.CocreateNewExperiencesWithYourGuests' | translate }}
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="!photoAdvocacy?.isActive">
                                    <p>
                                        <span class="ft-text-plus-1">{{'flipto.account.LearnMore' | translate }} <i class="ft-icn-arrow-right"></i></span>
                                    </p>
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="photoAdvocacy?.isActive">
                                    <p>
                                        {{guestsAndFriends?.photoContest?.contestCount | number}}
                                        <ng-pluralize count="guestsAndFriends.photoContest.contestCount" when="{'one': 'campaign', 'other': 'campaigns'}" />,
                                        {{guestsAndFriends?.photoContest?.finalistCount | number}}
                                        <ng-pluralize count="guestsAndFriends.photoContest.finalistCount" when="{'one': 'storyteller', 'other': 'storytellers'}" />
                                    </p>
                                    <p>
                                        <span class="ft-count ft-text-plus-3">{{guestsAndFriends?.photoContest?.reach | number}}</span>
                                        <span class="ft-text-plus-1">{{'flipto.account.FriendsReached' | translate | lowercase}}</span>
                                    </p>
                                </div>
                                <div class="ft-panel-image-container">
                                    <div class="ft-perspective-container">
                                        <div class="ft-panel-image ft-screenshot ft-screen-storygallery">
                                            <div class="ft-browserchrome"></div>
                                            <div class="ft-browserviewport"></div>
                                            <div class="ft-panel-image-caption">
                                                <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </collapsed>
                            <primary *ngIf="!photoAdvocacy?.isActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">
                                    {{'flipto.account.TurnGuestsIntoPowerfulStorytellers' | translate}}
                                </div>
                                <div class="ft-view-emptystate">
                                    <div class="ft-content ft-anim">
                                        <div class="ft-summary">
                                            <p>
                                                {{'flipto.account.LetYourGuestsStoriesPowerAConversionMachine' | translate}}
                                            </p>
                                            <p>
                                                {{'flipto.account.YoullGrowYourReachAndEarnNewWarmLeadsAlmostInstantly' | translate}}
                                            </p>
                                            <div class="ft-alert">
                                                <div class="ft-alert-content">
                                                    <h3 class="ft-heading">{{'flipto.account.ThisFeatureIsOff' | translate}}.</h3>
                                                    <p>
                                                        {{'flipto.account.ContactYourAccountManagerToLaunchThisFeature' | translate}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-panel intro" ft-targets-modal="audiences.guests.storytellers.intro">
                                            <div class="ft-panel-bg"></div>
                                            <div class="ft-panel-content">
                                                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                                                <div class="ft-label">{{'flipto.account.Storytellers' | translate}}</div>
                                                <i class="ft-icn-play"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </primary>
                            <primary *ngIf="photoAdvocacy?.isActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">
                                    {{'flipto.account.TurnGuestsIntoPowerfulStorytellers' | translate}}
                                </div>
                                <div class="ft-content ft-anim">
                                    <ft-sections [registry]="[{name: 'current', title: 'Current', isActive: true, isDisabled: false}, {name: 'upcoming', title: 'Upcoming', isActive: false, isDisabled: false}, {name: 'past', title: 'Past', isActive: false, isDisabled: false}]"
                                                 (afterInit)="saveSectionsRegistry('GeneralContests', $event.registry)">
                                        <div class="ft-view-emptystate" *ngIf="!photoAdvocacyCampaigns?.contests?.item?.length">
                                            <div class="ft-summary">
                                                <p>
                                                    {{'flipto.account.EngageGuestsWhoHaveHadPositiveMemoriesWithYourBrand' | translate}}
                                                </p>
                                            </div>
                                            <div class="ft-panel addnew" (click)="createNewContest(contestConstants.general)">
                                                <div class="ft-panel-bg"></div>
                                                <div class="ft-panel-content">
                                                    <i class="ft-icn-plus"></i> {{'flipto.account.CreateANewCampaign' | translate}}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="ft-view-contests-list">
                                            <!-- Contest ended -->
                                            <div class="ft-panel contest-panel current contest-active" *ngFor="let contest of (photoAdvocacyCampaigns?.contests?.item)"
                                                 (click)="showContest(contest, 'winners')">
                                                <div class="panel-image" [style.background-image]="'url(' + (getContestBackgroundImage(contest)) + ')'">
                                                    <div class="panel-matte"></div>
                                                </div>

                                                <div class="contest-display">
                                                    <div class="contest-display-content">
                                                        <div class="contest-title">{{contest.name}}</div>
                                                        <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
                                                        <div class="contest-status is-ended" [ngClass]="{'is-off': !(contest.isActive|parse:'bool')}">
                                                            <ft-contest-status [contest]="contest" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="contest-stats ft-v-align-container">
                                                    <div class="contest-stats-content ft-v-align-content">
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFinalists || 0) | number"
                                                                     [label]="'flipto.account.Storytellers' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalShares || 0) | number"
                                                                     [label]="'flipto.account.TotalShares' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFollowers || 0) | number"
                                                                     [label]="'flipto.account.FriendsReached' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalSignups || 0) | number"
                                                                     [label]="'flipto.account.WarmLeadsEarned' | translate | lowercase" />
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>

                                            <!-- Contest in progress -->
                                            <div class="ft-panel contest-panel current contest-active" *ngFor="let contest of (photoAdvocacyCampaigns?.contests?.item)"
                                                 (click)="showContest(contest, 'submissions')">
                                                <div class="panel-image" [style.background-image]="'url(' + (getContestBackgroundImage(contest)) + ')'">
                                                    <div class="panel-matte"></div>
                                                </div>

                                                <div class="contest-display ft-v-align-container">
                                                    <div class="contest-display-content ft-v-align-content">
                                                        <div class="contest-title" [innerHTML]="contest.name"></div>
                                                        <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
                                                        <div class="contest-status" *ngIf="!(contest.isActive|parse:'bool')"
                                                             [ngClass]="{'is-off': !(contest.isActive|parse:'bool')}">
                                                            <ft-contest-status [contest]="contest" />
                                                        </div>

                                                        <div class="ft-latest-stories" [hidden]="!(contest?.latestEntries?.item)">
                                                            <div class="contest-status is-latest">{{'flipto.account.LatestStories' | translate }}</div>
                                                            <div class="ft-content">
                                                                <div class="ft-story-slot"
                                                                     *ngFor="let latestEntry of (contest?.latestEntries?.item)"
                                                                     [style.background-image]="'url(' + azurePhoto(latestEntry, 'thumbnail') + ')'">
                                                                </div>
                                                                <!--<p *ngIf="((contest.totalPhotoSubmissions | parse:'number') - (contest.latestEntries | parse:'array').length) > 0">+{{(contest.totalPhotoSubmissions | parse:'number') - (contest.latestEntries | parse:'array').length}} more</p>-->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="contest-stats ft-v-align-container">
                                                    <div class="contest-stats-content ft-v-align-content">
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFinalists || 0) | number"
                                                                     [label]="'flipto.account.Storytellers' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalShares || 0) | number"
                                                                     [label]="'flipto.account.TotalShares' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFollowers || 0) | number"
                                                                     [label]="'flipto.account.FriendsReached' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalSignups || 0) | number"
                                                                     [label]="'flipto.account.WarmLeadsEarned' | translate | lowercase" />
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="ft-contest-tabs">
                                            View&nbsp;
                                            <ng-container *ngFor="let section of (ftSecsTop.registry)"><a *ngIf="section.name !== 'current'" [ngClass]="{'active': section.isActive}"
                                               [ftSectionTrigger]="section.isActive ? 'current' : section.name">{{section.name}}&nbsp;campaigns</a></ng-container>
                                        </div>

                                        <ft-section name="upcoming">
                                            <ft-contests-list select="upcoming" [theme]="contestConstants.general" />
                                        </ft-section>

                                        <ft-section name="past">
                                            <ft-contests-list select="past" [theme]="contestConstants.general" />
                                        </ft-section>
                                    </ft-sections>
                                </div>
                            </primary>
                            <secondary>
                                <panel class="addnew" (click)="createNewContest(contestConstants.general)" [hidden]="!(photoAdvocacyCampaigns?.contests?.item?.length)">
                                    <div class="ft-label">
                                        <i class="ft-icn-plus"></i> <span translate="flipto.account.CreateANewCampaign"></span>
                                    </div>
                                </panel>
                                <!--<panel class="clarity" ft-targets-modal="audiences.guests.poststay.clarity">
                                    <div class="ft-supertitle">{{'flipto.account.Clarity' | translate}}</div>
                                    <div class="ft-label">The value of storytellers</div>
                                </panel>-->
                                <panel class="variation" (click)="showCampaignDetails('post-stay', poststayCampaigns?.campaigns?.item?.[0]?.id)">
                                    <div class="ft-supertitle">Variation</div>
                                    <div class="ft-label">For guests who don't become storytellers</div>
                                </panel>
                                <panel class="intro" ft-targets-modal="audiences.guests.storytellers.intro">
                                    <div class="ft-supertitle" translate="flipto.account.Intro"></div>
                                    <div class="ft-label" translate="flipto.account.Storytellers"></div>
                                    <i class="ft-icn-play"></i>
                                </panel>
                            </secondary>
                        </ft-expandable-content>
                    </section>

                    <section class="ft-section">
                        <div class="ft-container">
                            <div class="ft-section-header">
                                <div class="ft-heading ft-text-plus-3">{{'flipto.account.BeforeYourGuestsStay' | translate}}</div>
                            </div>
                        </div>
                        <ft-expandable-content class="ft-buddingadvocates-expandable" [ngClass]="{'is-off': !prestayAdvocacy?.isActive}">
                            <collapsed>
                                <div class="ft-heading ft-anim ft-text-plus-2">
                                    {{'flipto.account.TurnGuestsIntoBuddingAdvocates' | translate}}
                                </div>
                                <div class="ft-summary ft-anim">
                                    {{'flipto.account.KickStartYourGuestsPathToAdvocacyEvenBeforeTheirTrip' | translate}}
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="!prestayAdvocacy?.isActive">
                                    <p>
                                        <span class="ft-text-plus-1">{{'flipto.account.LearnMore' | translate }} <i class="ft-icn-arrow-right"></i></span>
                                    </p>
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="prestayAdvocacy?.isActive">
                                    <p>
                                        {{guestsAndFriends?.prestay?.variationCount | number}}
                                        <ng-pluralize count="guestsAndFriends.prestay.variationCount" when="{'one': 'variation', 'other': 'variations'}" />,
                                        {{guestsAndFriends?.prestay?.advocateCount | number}}
                                        <ng-pluralize count="guestsAndFriends.prestay.advocateCount" when="{'one': 'advocate', 'other': 'advocates'}" />
                                    </p>
                                    <p>
                                        <span class="ft-count ft-text-plus-3">{{guestsAndFriends?.prestay?.reach | number}}</span>
                                        <span class="ft-text-plus-1">{{'flipto.account.FriendsReached' | translate | lowercase}}</span>
                                    </p>
                                </div>
                                <div class="ft-panel-image-container">
                                    <div class="ft-perspective-container">
                                        <div class="ft-panel-image ft-screenshot ft-screen-confirmationexperience-foryou">
                                            <div class="ft-browserchrome"></div>
                                            <div class="ft-browserviewport"></div>
                                            <div class="ft-panel-image-caption">
                                                <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </collapsed>
                            <primary *ngIf="!prestayAdvocacy?.isActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">
                                    {{'flipto.account.TurnGuestsIntoBuddingAdvocates' | translate}}
                                </div>
                                <div class="ft-view-emptystate">
                                    <div class="ft-content ft-anim">
                                        <div class="ft-summary">
                                            <p>
                                                {{'flipto.account.DontBeFooledByTheNameABuddingAdvocateHasTremendousPotential' | translate}}
                                            </p>
                                            <div class="ft-alert">
                                                <div class="ft-alert-content">
                                                    <h3 class="ft-heading">{{'flipto.account.ThisFeatureIsOff' | translate}}.</h3>
                                                    <p>
                                                        {{'flipto.account.ContactYourAccountManagerToLaunchThisFeature' | translate}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-panel intro" ft-targets-modal="audiences.guests.prestay.intro">
                                            <div class="ft-panel-bg"></div>
                                            <div class="ft-panel-content">
                                                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                                                <div class="ft-label">{{'flipto.account.BuddingAdvocates' | translate}}</div>
                                                <i class="ft-icn-play"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </primary>
                            <primary *ngIf="prestayAdvocacy?.isActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">
                                    {{'flipto.account.TurnGuestsIntoBuddingAdvocates' | translate}}
                                </div>
                                <div class="ft-content ft-anim">
                                    <div class="ft-stats ft-stats-1">
                                        <div class="mb-2">
                                            <ft-daterange-picker (changed)="onCalendarDateRangeChange($event)" [darkMode]="true" [pastDays]="7" />
                                        </div>
                                        <p>
                                            {{guestsAndFriends?.prestay?.guestCount | number}} guests were asked to share about their upcoming stay.
                                        </p>
                                        <p>
                                            <span class="ft-count ft-text-plus-3">
                                                {{guestsAndFriends?.prestay?.advocateCount | number}}
                                            </span>
                                            <span class="ft-text-plus-2">
                                                became advocates.
                                            </span>
                                        </p>
                                    </div>
                                    <div class="ft-stats ft-stats-2">
                                        <p>
                                            <span class="ft-count ft-text-plus-3">{{guestsAndFriends?.prestay?.reach | number}}</span>
                                            <span class="ft-text-plus-2">friends were reached.</span>
                                        </p>
                                        <p>
                                            {{guestsAndFriends?.prestay?.signupCount | number}} warm leads showed interest in a future stay.
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-section-image-container">
                                    <div class="ft-perspective-container ft-anim">
                                        <div class="ft-section-image ft-screenshot ft-screen-confirmationexperience-foryou">
                                            <div class="ft-browserchrome"></div>
                                            <div class="ft-browserviewport"></div>
                                            <div class="ft-section-image-caption">
                                                <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </primary>
                            <secondary>
                                <!--<panel class="clarity" ft-targets-modal="audiences.guests.prestay.clarity">
                                    <div class="ft-supertitle">{{'flipto.account.Clarity' | translate}}</div>
                                    <div class="ft-label">{{'flipto.account.TheValueOfBuddingAdvocates' | translate}}</div>
                                </panel>-->
                                <panel class="variation" ft-targets-modal="audiences.guests.prestay.variation">
                                    <div class="ft-supertitle" translate="flipto.account.Variations"></div>
                                    <div class="ft-label">Show your appreciation for guests who share</div>
                                </panel>
                                <panel class="intro" ft-targets-modal="audiences.guests.prestay.intro">
                                    <div class="ft-supertitle" translate="flipto.account.Intro"></div>
                                    <div class="ft-label" translate="flipto.account.BuddingAdvocates"></div>
                                    <i class="ft-icn-play"></i>
                                </panel>
                            </secondary>
                        </ft-expandable-content>
                    </section>
                </div>
            </ft-section>

            <ft-section name="visitors">
                <div class="ft-view ft-segment-visitors">
                    <!--<section class="ft-section ft-synopsis-section">
                        <div class="ft-container">
                            <div class="ft-section-image">
                                <div class="ft-org-logo" [style.background-image]="'url(' + (property?.logoUrl) + ')'"></div>
                            </div>
                            <div class="ft-content">
                                Inspire
                                <span class="ft-persona-scheme-visitors">website visitors</span> who are not yet ready to
                                book and give them a good reason to come back when they are.
                            </div>
                        </div>
                    </section>-->

                    <section class="ft-section">
                        <div class="ft-container">
                            <div class="ft-section-header">
                                <div class="ft-heading ft-text-plus-3">{{'flipto.account.ForTravelersInPlanningMode' | translate}}</div>
                            </div>
                        </div>
                        <ft-expandable-content class="ft-storyriver-expandable" [ngClass]="{'is-off': !photoAdvocacy?.isPhotoRiverActive}">
                            <collapsed>
                                <div class="ft-heading ft-anim ft-text-plus-2">{{'flipto.account.InspireWithStoryRiver' | translate}}</div>

                                <div class="ft-snapshot ft-anim" *ngIf="!photoAdvocacy?.isPhotoRiverActive">
                                    <p>
                                        <span class="ft-text-plus-1">{{'flipto.account.LearnMore' | translate }} <i class="ft-icn-arrow-right"></i></span>
                                    </p>
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="photoAdvocacy?.isPhotoRiverActive">
                                    <p>
                                        {{visitors?.photoRiver?.viewCount | number}} {{'flipto.account.VisitorsSawYourStoryRiver' | translate}}
                                    </p>
                                    <p>
                                        <span class="ft-count ft-text-plus-3">{{visitors?.photoRiver?.photoClickCount | number}}</span>
                                        <span class="ft-txt-plus-1">{{'flipto.account.CheckedOutAStory' | translate}}</span>
                                    </p>
                                </div>
                                <div class="ft-panel-image-container">
                                    <div class="ft-perspective-container">
                                        <div class="ft-panel-image ft-screenshot ft-screen-storyriver">
                                            <div class="ft-browserchrome"></div>
                                            <div class="ft-browserviewport"></div>
                                            <div class="ft-panel-image-caption">
                                                <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </collapsed>
                            <primary *ngIf="!photoAdvocacy?.isPhotoRiverActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">{{'flipto.account.InspireWithStoryRiver' | translate}}</div>
                                <div class="ft-view-emptystate">
                                    <div class="ft-content ft-anim">
                                        <div class="ft-summary">
                                            <p>
                                                {{'flipto.account.ShowYourWebsiteVisitorsAuthenticTravelStories' | translate}}
                                            </p>
                                            <p>
                                                {{'flipto.account.ASteadyFlowOfCurrentAuthenticStoriesShowsWebsiteVisitors' | translate}}
                                            </p>
                                            <div class="ft-alert">
                                                <div class="ft-alert-content">
                                                    <h3 class="ft-heading">{{'flipto.account.ThisFeatureIsNotActive' | translate}}.</h3>
                                                    <p>
                                                        {{'flipto.account.ContactYourAccountManagerToActivateThisFeature' | translate}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-panel intro" ft-targets-modal="audiences.visitors.storyriver.intro">
                                            <div class="ft-panel-bg"></div>
                                            <div class="ft-panel-content">
                                                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                                                <div class="ft-label">{{'flipto.account.StoryRiver' | translate}}</div>
                                                <i class="ft-icn-play"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </primary>
                            <primary *ngIf="photoAdvocacy?.isPhotoRiverActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">{{'flipto.account.InspireWithStoryRiver' | translate}}</div>
                                <div class="ft-content ft-anim">
                                    <div class="ft-stats">
                                        <p>
                                            {{visitors?.photoRiver?.viewCount | number}} {{'flipto.account.VisitorsSawYourStoryRiver' | translate}}
                                        </p>
                                        <p>
                                            <span class="ft-count ft-text-plus-3">{{visitors?.photoRiver?.photoClickCount | number}}</span>
                                            <span class="ft-txt-plus-1">{{'flipto.account.CheckedOutAStory' | translate}}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-section-image-container">
                                    <div class="ft-perspective-container ft-container ft-anim">
                                        <div class="ft-section-image ft-screenshot ft-screen-storyriver">
                                            <div class="ft-browserchrome"></div>
                                            <div class="ft-browserviewport"></div>
                                            <div class="ft-section-image-caption">
                                                <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </primary>
                            <secondary>
                                <!--<panel class="clarity" ft-targets-modal="audiences.visitors.storyriver.clarity">
                                    <div class="ft-supertitle">{{'flipto.account.Clarity' | translate}}</div>
                                    <div class="ft-label">The impact of Story River</div>
                                </panel>-->
                                <panel class="variation" [hidden]="!(isGeneralVariation)" (click)="showGeneralThemeCampaignDetails()">
                                    <div class="ft-supertitle" translate="flipto.account.Variation"></div>
                                    <div class="ft-label">Provide a bonus for warm leads</div>
                                </panel>
                                <panel class="intro" ft-targets-modal="audiences.visitors.storyriver.intro">
                                    <div class="ft-supertitle" translate="flipto.account.Intro"></div>
                                    <div class="ft-label" translate="flipto.account.StoryRiver"></div>
                                    <i class="ft-icn-play"></i>
                                </panel>
                            </secondary>
                        </ft-expandable-content>

                        <div class="ft-expandable-layout-columns-2">
                            <ft-expandable-content class="ft-hpc-expandable" [ngClass]="{'is-off': !homepageAdvocacy?.isActive}">
                                <collapsed>
                                    <div class="ft-heading ft-anim ft-text-plus-2">{{'flipto.account.UnlockFutureAdvocatesWithHPC' | translate}}</div>

                                    <div class="ft-snapshot ft-anim" *ngIf="!homepageAdvocacy?.isActive">
                                        <p>
                                            <span class="ft-text-plus-1">{{'flipto.account.LearnMore' | translate }} <i class="ft-icn-arrow-right"></i></span>
                                        </p>
                                    </div>

                                    <div class="ft-snapshot ft-anim" *ngIf="homepageAdvocacy?.isActive">
                                        <p>
                                            <span class="ft-count ft-text-plus-3">{{visitors?.homepage?.viewCount | number}}</span>
                                            <span class="ft-txt-plus-1">{{'flipto.account.VisitorsSawYourHPC' | translate}}</span>
                                        </p>
                                    </div>
                                    <div class="ft-panel-image-container">
                                        <div class="ft-perspective-container">
                                            <div class="ft-panel-image ft-screenshot ft-screen-hpc">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-panel-image-caption">
                                                    <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </collapsed>
                                <primary *ngIf="!homepageAdvocacy?.isActive">
                                    <div class="ft-heading ft-anim ft-text-plus-3">{{'flipto.account.UnlockFutureAdvocatesWithHPC' | translate}}.</div>
                                    <div class="ft-view-emptystate">
                                        <div class="ft-content ft-anim">
                                            <div class="ft-summary">
                                                <p>
                                                    {{'flipto.account.GiveVisitorsWhoAreNotReadyToBookNowAnEasyWayBack' | translate}}
                                                </p>
                                                <p>
                                                    {{'flipto.account.MostWebsiteVisitorsComeToYourSiteToResearch' | translate}}
                                                </p>
                                                <div class="ft-alert">
                                                    <div class="ft-alert-content">
                                                        <h3 class="ft-heading">{{'flipto.account.ThisFeatureIsOff' | translate}}.</h3>
                                                        <p>
                                                            {{'flipto.account.ContactYourAccountManagerToLaunchThisFeature' | translate}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ft-section-image-container">
                                        <div class="ft-perspective-container ft-container ft-anim">
                                            <div class="ft-section-image ft-screenshot ft-screen-hpc">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </primary>
                                <primary *ngIf="homepageAdvocacy?.isActive">
                                    <div class="ft-heading ft-anim ft-text-plus-3">{{'flipto.account.UnlockFutureAdvocatesWithHPC' | translate}}.</div>
                                    <div class="ft-content ft-anim">
                                        <div class="ft-stats">
                                            <p>
                                                {{visitors?.homepage?.viewCount | number}} {{'flipto.account.VisitorsSawYourHPC' | translate}}
                                                {{visitors?.homepage?.signupViewCount | number}} interacted with it.
                                            </p>
                                            <p>
                                                <span class="ft-count ft-text-plus-3">
                                                    {{visitors?.homepage?.bookingClickCount | number}}
                                                </span>
                                                <span class="ft-txt-plus-1">started booking.</span>
                                            </p>
                                            <p>
                                                <span class="ft-count ft-text-plus-3">
                                                    {{visitors?.homepage?.warmLeadCount | number}}
                                                </span>
                                                <span class="ft-txt-plus-1">
                                                    unlocked their bonus and became warm leads for
                                                    a future stay.
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="ft-section-image-container">
                                        <div class="ft-perspective-container ft-container ft-anim">
                                            <div class="ft-section-image ft-screenshot ft-screen-hpc">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </primary>
                                <!--<secondary>
                                    <panel class="clarity">
                                        <div class="ft-supertitle">{{'flipto.account.Clarity' | translate}}</div>
                                        <div class="ft-label">The impact of HPC</div>
                                    </panel>
                                    <panel class="intro" ft-targets-modal="audiences.visitors.hpc.intro">
                                        <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                                        <div class="ft-label">HPC</div>
                                        <i class="ft-icn-play"></i>
                                    </panel>
                                </secondary>-->
                            </ft-expandable-content>

                            <ft-expandable-content class="ft-quoteslist-expandable" [ngClass]="{'is-off': !quoteListAdvocacy?.isActive}">
                                <collapsed>
                                    <div class="ft-heading ft-anim ft-text-plus-2">
                                        Showcase guest highlights with Quotes List.
                                    </div>

                                    <div class="ft-snapshot ft-anim" *ngIf="!quoteListAdvocacy?.isActive">
                                        <p>
                                            <span class="ft-text-plus-1">{{'flipto.account.LearnMore' | translate }} <i class="ft-icn-arrow-right"></i></span>
                                        </p>
                                    </div>

                                    <div class="ft-snapshot ft-anim" *ngIf="quoteListAdvocacy?.isActive">
                                        <p>
                                            <span class="ft-count ft-text-plus-3">{{visitors?.quote?.viewCount | number}}</span>
                                            <span class="ft-txt-plus-1">visitors viewed your Quotes List</span>
                                        </p>
                                    </div>
                                    <div class="ft-panel-image-container">
                                        <div class="ft-perspective-container">
                                            <div class="ft-panel-image ft-screenshot ft-screen-quoteslist">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-panel-image-caption">
                                                    <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </collapsed>
                                <primary *ngIf="!quoteListAdvocacy?.isActive">
                                    <div class="ft-heading ft-anim ft-text-plus-3">
                                        Showcase guest highlights with Quotes List.
                                    </div>
                                    <div class="ft-view-emptystate">
                                        <div class="ft-content ft-anim">
                                            <div class="ft-summary">
                                                <p>
                                                    Show visitors genuine testimonials revealing the best experiences that recent guests
                                                    had at your hotel.
                                                </p>
                                                <div class="ft-alert">
                                                    <div class="ft-alert-content">
                                                        <h3 class="ft-heading">{{'flipto.account.ThisFeatureIsOff' | translate}}.</h3>
                                                        <p>
                                                            {{'flipto.account.ContactYourAccountManagerToLaunchThisFeature' | translate}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ft-section-image-container">
                                        <div class="ft-perspective-container ft-container ft-anim">
                                            <div class="ft-section-image ft-screenshot ft-screen-quoteslist">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </primary>
                                <primary *ngIf="quoteListAdvocacy?.isActive">
                                    <div class="ft-heading ft-anim ft-text-plus-3">
                                        Showcase guest highlights with Quotes List.
                                    </div>
                                    <div class="ft-content ft-anim">
                                        <div class="ft-stats">
                                            <p>
                                                <span class="ft-count ft-text-plus-3">{{visitors?.quote?.viewCount | number}}</span>
                                                <span class="ft-txt-plus-1">visitors viewed your Quotes List.</span>
                                            </p>
                                            <p>
                                                {{visitors?.quote?.quoteCount | number}} quotes are available for display that are always current, genuine, and positive.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="ft-section-image-container">
                                        <div class="ft-perspective-container ft-container ft-anim">
                                            <div class="ft-section-image ft-screenshot ft-screen-quoteslist">
                                                <div class="ft-browserchrome"></div>
                                                <div class="ft-browserviewport"></div>
                                                <div class="ft-section-image-caption">
                                                    <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </primary>

                                <!--<secondary>
                                    <panel class="intro" ft-targets-modal="audiences.visitors.quoteslist.intro">
                                        <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                                        <div class="ft-label">Quotes List</div>
                                        <i class="ft-icn-play"></i>
                                    </panel>
                                </secondary>-->
                            </ft-expandable-content>
                        </div>
                    </section>
                </div>
            </ft-section>

            <ft-section name="fans">
                <div class="ft-view ft-segment-fans">
                    <!--<section class="ft-section ft-synopsis-section">
                        <div class="ft-container">
                            <div class="ft-section-image"></div>
                            <div class="ft-content">
                                Inspire
                                <span class="ft-persona-scheme-fans">fans &amp; followers</span> with unique, personal content
                                through stories told by your guests.
                            </div>
                        </div>
                    </section>-->

                    <section class="ft-section">
                        <div class="ft-container">
                            <div class="ft-section-header">
                                <div class="ft-heading ft-text-plus-3">{{'flipto.account.BroadcastWorthy' | translate}}</div>
                            </div>
                        </div>

                        <ft-expandable-content class="ft-broadcast-expandable recommendation seasonal" *ngIf="seasonalPhotos?.Photos?.length > 0"
                                               [collapsedBgImage]="(seasonalPhotos?.Photos || [])[0]?.PhotoUriSmall">
                            <collapsed>
                                <div class="ft-supertitle ft-anim">{{'flipto.account.Recommended' | translate}}</div>
                                <div class="ft-heading ft-anim ft-text-plus-2">
                                    {{'flipto.account.ShareASeasonalTravelStory' | translate}}
                                </div>
                                <div class="ft-summary ft-anim">
                                    {{'flipto.account.GetTravelersThinkingAboutYourHotelWithTimelyStories' | translate}}
                                </div>
                            </collapsed>
                            <primary>
                                <div class="ft-supertitle ft-anim">Recommended</div>
                                <div class="ft-heading ft-anim ft-text-plus-3">
                                    {{'flipto.account.ShareASeasonalTravelStory' | translate}}
                                </div>
                                <div class="ft-content ft-anim">
                                    <div class="ft-summary">
                                        {{'flipto.account.HereAreTheHighestRatedStoriesFromGuestsWhoStayedAroundTheSameTime' | translate}}
                                    </div>
                                    <div class="ft-broadcast-recommendations-list">
                                        <ul>
                                            <li *ngFor="let story of (seasonalPhotos?.Photos)">
                                                <ft-story-highlight [story]="story" (selected)="openShareModal(story)" />
                                            </li>
                                        </ul>
                                        <ft-paging (pageChange)="seasonalPhotosApiPageChange($event)">
                                            <div class="ft-pagination">
                                                <button class="ft-btn ft-btn-outline-light" ft-prev-page>Previous</button>
                                                <button class="ft-btn ft-btn-outline-light" ft-next-page [hasNextPage]="seasonalPhotos?.HasNextPage">More stories</button>
                                            </div>
                                        </ft-paging>
                                    </div>
                                </div>

                            </primary>
                        </ft-expandable-content>

                        <section class="ft-expandable-layout-columns-2">
                            <ft-expandable-content class="ft-broadcast-expandable recommendation general-stories">
                                <collapsed>
                                    <div class="ft-heading ft-anim">
                                        {{'flipto.account.ShareAGuestStory' | translate}}
                                    </div>
                                    <div class="ft-panel-image-container">
                                        <div class="ft-panel-image">
                                            <div class="ft-dynamic-image" [style.background-image]="'url(' + ((randomPhotos?.Photos || [])[0]?.PhotoUriSmall) + ')'"></div>
                                        </div>
                                    </div>
                                </collapsed>
                                <primary *ngIf="!(randomPhotos?.Photos?.length &gt; 0)">
                                    <div class="ft-heading ft-anim ft-text-plus-2">
                                        {{'flipto.account.ShareAGuestStory' | translate}}
                                    </div>
                                    <div class="ft-view-emptystate">
                                        <div class="ft-content ft-anim">
                                            <div class="ft-summary">
                                                <p>
                                                    {{'flipto.account.YouHaveNothingToBroadcastAtTheMoment' | translate}}
                                                </p>
                                                <p>
                                                    {{'flipto.account.AfterYouReceiveSomeNewStoriesWellBringYouTheHighestRated' | translate}}
                                                </p>
                                                <p>
                                                    {{'flipto.account.ToSeeAllYourStoriesGoToYour' | translate}} <a href="" class="ft-link-underline" (click)="goToLibrary()">{{'flipto.account.Library' | translate | lowercase}}</a>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </primary>
                                <primary *ngIf="randomPhotos?.Photos?.length > 0">
                                    <div class="ft-heading ft-anim ft-text-plus-2">
                                        {{'flipto.account.ShareAGuestStory' | translate}}
                                    </div>
                                    <div class="ft-content ft-anim">
                                        <div class="ft-summary">
                                            {{'flipto.account.HereAreTheHighestRatedStoriesFromYourLibrary' | translate}}
                                        </div>
                                        <div class="ft-broadcast-recommendations-list">
                                            <ul>
                                                <li *ngFor="let story of (randomPhotos?.Photos)">
                                                    <ft-story-highlight [story]="story" (selected)="openShareModal(story)" />
                                                </li>
                                            </ul>
                                            <ft-paging (pageChange)="randomPhotosApiPageChange($event)">
                                                <div class="ft-pagination">
                                                    <button class="ft-btn ft-btn-outline-dark" ft-prev-page>Previous</button>
                                                    <button class="ft-btn ft-btn-outline-dark" ft-next-page [hasNextPage]="randomPhotos?.HasNextPage">More stories</button>
                                                </div>
                                            </ft-paging>
                                            <p>
                                                {{'flipto.account.ToSeeAllYourStoriesGoToYour' | translate}} <a href="" class="ft-link-underline" (click)="goToLibrary()">{{'flipto.account.Library' | translate | lowercase}}</a>.
                                            </p>
                                        </div>
                                    </div>
                                </primary>
                            </ft-expandable-content>

                            <ft-expandable-content class="ft-broadcast-expandable recommendation stories-from-current-campaign" *ngIf="photoAdvocacy?.isActive">
                                <collapsed>
                                    <div class="ft-heading ft-anim">
                                        {{'flipto.account.HighlightAStoryFromACurrentCampaign' | translate}}
                                    </div>
                                    <div class="ft-panel-image-container">
                                        <div class="ft-panel-image">
                                            <div class="ft-dynamic-image" [style.background-image]="'url(' + ((currentCampaignPhotos?.Photos || [])[0]?.PhotoUriSmall) + ')'"></div>
                                        </div>
                                    </div>
                                </collapsed>
                                <primary *ngIf="!(currentCampaignPhotos?.Photos?.length &gt; 0)">
                                    <div class="ft-heading ft-anim ft-text-plus-2">
                                        {{'flipto.account.HighlightAStoryFromACurrentCampaign' | translate}}
                                    </div>
                                    <div class="ft-view-emptystate">
                                        <div class="ft-content ft-anim">
                                            <div class="ft-summary">
                                                <p>
                                                    {{'flipto.account.YouHaveNothingToBroadcastAtTheMoment' | translate}}
                                                </p>
                                                <p>
                                                    {{'flipto.account.AfterYouReceiveSomeNewStoriesWellBringYouTheHighestRatedFromCampaigns' | translate}}
                                                </p>
                                                <p>
                                                    {{'flipto.account.ToSeeAllYourStoriesGoToYour' | translate}} <a href="" class="ft-link-underline" (click)="goToLibrary()">{{'flipto.account.Library' | translate | lowercase}}</a>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </primary>
                                <primary *ngIf="currentCampaignPhotos?.Photos?.length > 0">
                                    <div class="ft-heading ft-anim ft-text-plus-2">
                                        {{'flipto.account.HighlightAStoryFromACurrentCampaign' | translate}}
                                    </div>
                                    <div class="ft-content ft-anim">
                                        <div class="ft-summary">
                                            {{'flipto.account.HereAreTheHighestRatedStoriesFromYourCurrentCampaigns' | translate}}
                                        </div>
                                        <div class="ft-broadcast-recommendations-list">
                                            <ul>
                                                <li *ngFor="let story of (currentCampaignPhotos?.Photos)">
                                                    <ft-story-highlight [story]="story" (selected)="openShareModal(story)" />
                                                </li>
                                            </ul>
                                            <ft-paging (pageChange)="currentCampaignPhotosApiPageChange($event)">
                                                <div class="ft-pagination">
                                                    <button class="ft-btn ft-btn-outline-dark" ft-prev-page>Previous</button>
                                                    <button class="ft-btn ft-btn-outline-dark" ft-next-page [hasNextPage]="currentCampaignPhotos?.HasNextPage">More stories</button>
                                                </div>
                                            </ft-paging>
                                            <p>
                                                {{'flipto.account.ToSeeAllYourStoriesGoToYour' | translate}} <a href="" class="ft-link-underline" (click)="goToLibrary()">{{'flipto.account.Library' | translate | lowercase}}</a>.
                                            </p>
                                        </div>
                                    </div>
                                </primary>
                            </ft-expandable-content>

                            <ft-expandable-content class="ft-broadcast-expandable recommendation campaign-invitation" *ngIf="currentCampaignPhotos?.ContestUUID">
                                <collapsed>
                                    <div class="ft-heading ft-anim">
                                        {{'flipto.account.InviteTravelersToTellTheirOwnStory' | translate}}
                                    </div>
                                    <div class="ft-panel-image-container">
                                        <div class="ft-panel-image"></div>
                                    </div>
                                </collapsed>
                                <primary>
                                    <div class="ft-heading ft-anim ft-text-plus-2">
                                        {{'flipto.account.InviteTravelersToTellTheirOwnStory' | translate}}
                                    </div>
                                    <div class="ft-content ft-anim">
                                        <div class="ft-summary">
                                            {{'flipto.account.HereAreTheLatestCampaignsThatAreRunning' | translate}}
                                        </div>
                                        <div class="ft-broadcast-recommendations-list">
                                            <div class="ft-panel contest-panel current contest-active" *ngFor="let contest of (photoAdvocacyCampaigns?.contests?.item)"
                                                 (click)="showContest(contest, 'invitations')">
                                                <div class="panel-image" [style.background-image]="'url(' + (getContestBackgroundImage(contest)) + ')'">
                                                    <div class="panel-matte"></div>
                                                </div>

                                                <div class="contest-display">
                                                    <div class="contest-display-content">
                                                        <div class="contest-title" [innerHTML]="contest.name"></div>
                                                        <div class="contest-date-range">
                                                            {{contest.startDate | dateRange:contest.endDate}}
                                                        </div>
                                                        <div class="contest-status" *ngIf="contest.totalUncuratedPhotos > 0 || !(contest.isActive|parse:'bool')" [ngClass]="{'is-off': !(contest.isActive|parse:'bool')}">
                                                            <ft-contest-status [contest]="contest" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="contest-stats ft-v-align-container">
                                                    <div class="contest-stats-content ft-v-align-content">
                                                        <p>
                                                            <ft-stat [label]="'flipto.account.sections.platform.photoAdvocacy.Submissions' | translate | lowercase" [value]="(contest.totalPhotoSubmissions || 0) | number" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [label]="'flipto.account.Storytellers' | translate | lowercase" [value]="(contest.totalFinalists || 0) | number" />
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </primary>
                            </ft-expandable-content>
                        </section>

                    </section>
                </div>
            </ft-section>

            <ft-section name="wedding">
                <div class="ft-view ft-segment-wedding">

                    <!--<section class="ft-section ft-synopsis-section">
                        <div class="ft-container">
                            <div class="ft-section-image">
                                <div class="ft-org-logo" [style.background-image]="'url(' + (property?.logoUrl) + ')'"></div>
                            </div>
                            <div class="ft-content">
                                Let your
                                <span class="ft-persona-scheme-wedding">wedding guests</span> introduce your hotel with captivating
                                stories that inspire future brides and grooms to consider your hotel for their own wedding.
                            </div>
                        </div>
                    </section>-->

                    <section class="ft-section">
                        <div class="ft-container">
                            <div class="ft-section-header">
                                <div class="ft-heading ft-text-plus-3">{{'flipto.account.AfterYourGuestsWeddingEvent' | translate}}</div>
                            </div>
                        </div>
                        <ft-expandable-content class="ft-weddingstorytellers-expandable" [ngClass]="{'is-off': !photoAdvocacy?.isActive}" (afterCollapsed)="resetSection('WeddingContests')">
                            <collapsed>
                                <div class="ft-heading ft-anim ft-text-plus-2">
                                    {{'flipto.account.TurnWeddingGuestsIntoPowerfulStorytellers' | translate }}
                                </div>
                                <div class="ft-summary ft-anim">
                                    {{'flipto.account.CocreateNewExperiencesWithYourGuests' | translate }}
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="!photoAdvocacy?.isActive">
                                    <p>
                                        <span class="ft-text-plus-1">{{'flipto.account.LearnMore' | translate }} <i class="ft-icn-arrow-right"></i></span>
                                    </p>
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="photoAdvocacy?.isActive">
                                    <p>
                                        {{weddings?.photoContest?.contestCount | number}}
                                        <ng-pluralize count="weddings.photoContest.contestCount" when="{'one': 'campaign', 'other': 'campaigns'}" />,
                                        {{weddings?.photoContest?.finalistCount | number}}
                                        <ng-pluralize count="weddings.photoContest.finalistCount" when="{'one': 'storyteller', 'other': 'storytellers'}" />
                                    </p>
                                    <p>
                                        <span class="ft-count ft-text-plus-3">{{weddings?.photoContest?.reach | number}}</span>
                                        <span class="ft-text-plus-1">{{'flipto.account.FriendsReached' | translate | lowercase}}</span>
                                    </p>
                                </div>
                                <div class="ft-panel-image-container">
                                    <div class="ft-perspective-container">
                                        <div class="ft-panel-image ft-screenshot ft-screen-storygallery">
                                            <div class="ft-browserchrome"></div>
                                            <div class="ft-browserviewport"></div>
                                            <div class="ft-panel-image-caption">
                                                <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </collapsed>
                            <primary *ngIf="!photoAdvocacy?.isActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">
                                    {{'flipto.account.TurnWeddingGuestsIntoPowerfulStorytellers' | translate }}
                                </div>
                                <div class="ft-view-emptystate">
                                    <div class="ft-content ft-anim">
                                        <div class="ft-summary">
                                            <p>
                                                {{'flipto.account.LetYourGuestsStoriesPowerAConversionMachine' | translate }}
                                            </p>
                                            <p>
                                                {{'flipto.account.YoullGrowYourReachAndEarnNewWarmLeadsAlmostInstantly' | translate }}
                                            </p>
                                            <div class="ft-alert">
                                                <div class="ft-alert-content">
                                                    <h3 class="ft-heading">{{'flipto.account.ThisFeatureIsOff' | translate}}.</h3>
                                                    <p>
                                                        {{'flipto.account.ContactYourAccountManagerToLaunchThisFeature' | translate}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-panel intro" ft-targets-modal="audiences.wedding.storytellers.intro">
                                            <div class="ft-panel-bg"></div>
                                            <div class="ft-panel-content">
                                                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                                                <div class="ft-label">{{'flipto.account.WeddingStorytellers' | translate}}</div>
                                                <i class="ft-icn-play"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </primary>
                            <primary *ngIf="photoAdvocacy?.isActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">
                                    {{'flipto.account.TurnWeddingGuestsIntoPowerfulStorytellers' | translate }}
                                </div>
                                <div class="ft-content ft-anim">
                                    <ft-sections [registry]="[{name: 'current', title: 'Current', isActive: true, isDisabled: false}, {name: 'upcoming', title: 'Upcoming', isActive: false, isDisabled: false}, {name: 'past', title: 'Past', isActive: false, isDisabled: false}]"
                                                 (afterInit)="saveSectionsRegistry('WeddingContests', $event.registry)">
                                        <div class="ft-view-emptystate" [hidden]="photoAdvocacyCampaigns?.contests?.item?.length">
                                            <div class="ft-summary">
                                                <p>
                                                    {{'flipto.account.EngageGuestsWhoHaveHadPositiveMemoriesWithYourBrand' | translate}}
                                                </p>
                                            </div>
                                            <div class="ft-panel addnew" (click)="createNewContest(contestConstants.weddings)">
                                                <div class="ft-panel-bg"></div>
                                                <div class="ft-panel-content">
                                                    <i class="ft-icn-plus"></i> {{'flipto.account.CreateANewCampaign' | translate}}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="ft-view-contests-list">
                                            <!-- Contest ended -->
                                            <div class="ft-panel contest-panel current contest-active" *ngFor="let contest of (photoAdvocacyCampaigns?.contests?.item)"
                                                 (click)="showContest(contest, 'winners')">
                                                <div class="panel-image" [style.background-image]="'url(' + (getContestBackgroundImage(contest)) + ')'">
                                                    <div class="panel-matte"></div>
                                                </div>

                                                <div class="contest-display">
                                                    <div class="contest-display-content">
                                                        <div class="contest-title">{{contest.name}}</div>
                                                        <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
                                                        <div class="contest-status is-ended" [ngClass]="{'is-off': !(contest.isActive|parse:'bool')}">
                                                            <ft-contest-status [contest]="contest" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="contest-stats ft-v-align-container">
                                                    <div class="contest-stats-content ft-v-align-content">
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFinalists || 0) | number"
                                                                     [label]="'flipto.account.Storytellers' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalShares || 0) | number"
                                                                     [label]="'flipto.account.TotalShares' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFollowers || 0) | number"
                                                                     [label]="'flipto.account.FriendsReached' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalSignups || 0) | number"
                                                                     [label]="'flipto.account.WarmLeadsEarned' | translate | lowercase" />
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>

                                            <!-- Contest in progress -->
                                            <div class="ft-panel contest-panel current contest-active" *ngFor="let contest of (photoAdvocacyCampaigns?.contests?.item)"
                                                 (click)="showContest(contest, 'submissions')">
                                                <div class="panel-image" [style.background-image]="'url(' + (getContestBackgroundImage(contest)) + ')'">
                                                    <div class="panel-matte"></div>
                                                </div>

                                                <div class="contest-display ft-v-align-container">
                                                    <div class="contest-display-content ft-v-align-content">
                                                        <div class="contest-title" [innerHTML]="contest.name"></div>
                                                        <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
                                                        <div class="contest-status" *ngIf="!(contest.isActive|parse:'bool')"
                                                             [ngClass]="{'is-off': !(contest.isActive|parse:'bool')}">
                                                            <ft-contest-status [contest]="contest" />
                                                        </div>

                                                        <div class="ft-latest-stories" [hidden]="!(contest?.latestEntries?.item)">
                                                            <div class="contest-status is-latest">{{'flipto.account.LatestStories' | translate }}</div>
                                                            <div class="ft-content">
                                                                <div class="ft-story-slot"
                                                                     *ngFor="let latestEntry of (contest?.latestEntries?.item)"
                                                                     [style.background-image]="'url(' + azurePhoto(latestEntry, 'thumbnail') + ')'">
                                                                </div>
                                                                <!--<p *ngIf="((contest.totalPhotoSubmissions | parse:'number') - (contest.latestEntries | parse:'array').length) > 0">+{{(contest.totalPhotoSubmissions | parse:'number') - (contest.latestEntries | parse:'array').length}} more</p>-->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="contest-stats ft-v-align-container">
                                                    <div class="contest-stats-content ft-v-align-content">
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFinalists || 0) | number"
                                                                     [label]="'flipto.account.Storytellers' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalShares || 0) | number"
                                                                     [label]="'flipto.account.TotalShares' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFollowers || 0) | number"
                                                                     [label]="'flipto.account.FriendsReached' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalSignups || 0) | number"
                                                                     [label]="'flipto.account.WarmLeadsEarned' | translate | lowercase" />
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="ft-contest-tabs">
                                            View&nbsp;
                                            <ng-container *ngFor="let section of (ftSecsTop.registry)"><a *ngIf="section.name !== 'current'" [ngClass]="{'active': section.isActive}"
                                               [ftSectionTrigger]="section.isActive ? 'current' : section.name">{{section.name}}&nbsp;campaigns</a></ng-container>
                                        </div>

                                        <ft-section name="upcoming">
                                            <ft-contests-list select="upcoming" [theme]="contestConstants.weddings" />
                                        </ft-section>

                                        <ft-section name="past">
                                            <ft-contests-list select="past" [theme]="contestConstants.weddings" />
                                        </ft-section>
                                    </ft-sections>
                                </div>
                            </primary>
                            <secondary>
                                <panel class="addnew" (click)="createNewContest(contestConstants.weddings)" [hidden]="!(photoAdvocacyCampaigns?.contests?.item?.length)">
                                    <div class="ft-label">
                                        <i class="ft-icn-plus"></i><span translate="flipto.account.CreateANewCampaign"></span>
                                    </div>
                                </panel>
                                <!--<panel class="clarity">
                                    <div class="ft-supertitle">{{'flipto.account.Clarity' | translate}}</div>
                                    <div class="ft-label">Value of wedding storytellers</div>
                                </panel>-->
                                <panel class="intro" ft-targets-modal="audiences.wedding.storytellers.intro">
                                    <div class="ft-supertitle" translate="flipto.account.Intro"></div>
                                    <div class="ft-label" translate="flipto.account.WeddingStorytellers"></div>
                                    <i class="ft-icn-play"></i>
                                </panel>
                            </secondary>
                        </ft-expandable-content>
                    </section>
                    <section class="ft-section">
                        <div class="ft-container">
                            <div class="ft-section-header">
                                <div class="ft-heading ft-text-plus-3">{{'flipto.account.ForTravelersWhoArePlanningTheirWedding' | translate}}</div>
                            </div>
                        </div>
                        <ft-expandable-content class="ft-weddingstoryriver-expandable" [ngClass]="{'is-off': !photoAdvocacy?.isPhotoRiverActive}">
                            <collapsed>
                                <div class="ft-heading ft-anim ft-text-plus-2">
                                    {{'flipto.account.InspireWithStoryRiver' | translate}}
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="!photoAdvocacy?.isPhotoRiverActive">
                                    <p>
                                        <span class="ft-text-plus-1">{{'flipto.account.LearnMore' | translate }} <i class="ft-icn-arrow-right"></i></span>
                                    </p>
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="photoAdvocacy?.isPhotoRiverActive">
                                    <p>
                                        {{weddings?.photoRiver?.viewCount | number}} {{'flipto.account.VisitorsSawYourStoryRiver' | translate}}
                                    </p>
                                    <p>
                                        <span class="ft-count ft-text-plus-3">{{weddings?.photoRiver?.photoClickCount | number}}</span>
                                        <span class="ft-text-plus-1">{{'flipto.account.CheckedOutAStory' | translate}}</span>
                                    </p>
                                </div>
                                <div class="ft-panel-image-container">
                                    <div class="ft-perspective-container">
                                        <div class="ft-panel-image ft-screenshot ft-screen-storyriver-wedding">
                                            <div class="ft-browserchrome"></div>
                                            <div class="ft-browserviewport"></div>
                                            <div class="ft-panel-image-caption">
                                                <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </collapsed>
                            <primary *ngIf="!photoAdvocacy?.isPhotoRiverActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">{{'flipto.account.InspireWithStoryRiver' | translate}}</div>
                                <div class="ft-view-emptystate">
                                    <div class="ft-content ft-anim">
                                        <div class="ft-summary">
                                            <p>
                                                {{'flipto.account.ShowYourWebsiteVisitorsAuthenticTravelStories' | translate}}
                                            </p>
                                            <p>
                                                {{'flipto.account.ASteadyFlowOfCurrentAuthenticStoriesShowsWebsiteVisitors' | translate}}
                                            </p>
                                            <div class="ft-alert">
                                                <div class="ft-alert-content">
                                                    <h3 class="ft-heading">{{'flipto.account.ThisFeatureIsNotActive' | translate}}.</h3>
                                                    <p>
                                                        {{'flipto.account.ContactYourAccountManagerToActivateThisFeature' | translate}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-panel intro" ft-targets-modal="audiences.wedding.storyriver.intro">
                                            <div class="ft-panel-bg"></div>
                                            <div class="ft-panel-content">
                                                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                                                <div class="ft-label">{{'flipto.account.StoryRiver' | translate}}</div>
                                                <i class="ft-icn-play"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </primary>
                            <primary *ngIf="photoAdvocacy?.isPhotoRiverActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">{{'flipto.account.InspireWithStoryRiver' | translate}}</div>
                                <div class="ft-content ft-anim">
                                    <div class="ft-stats">
                                        <p>
                                            {{weddings?.photoRiver?.viewCount | number}} {{'flipto.account.VisitorsSawYourStoryRiver' | translate}}
                                        </p>
                                        <p>
                                            <span class="ft-count ft-text-plus-3">{{weddings?.photoRiver?.photoClickCount | number}}</span>
                                            <span class="ft-txt-plus-1">{{'flipto.account.CheckedOutAStory' | translate}}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="ft-section-image-container">
                                    <div class="ft-perspective-container ft-container ft-anim">
                                        <div class="ft-section-image ft-screenshot ft-screen-storyriver-wedding">
                                            <div class="ft-browserchrome"></div>
                                            <div class="ft-browserviewport"></div>
                                            <div class="ft-section-image-caption">
                                                <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </primary>
                            <secondary>
                                <!--<panel class="clarity">
                                    <div class="ft-supertitle">Clarity</div>
                                    <div class="ft-label">Heading for this action</div>
                                </panel>-->
                                <panel class="variation" [hidden]="!(isWeddingVariation)" (click)="showThemeCampaignDetails(contestConstants.weddings)">
                                    <div class="ft-supertitle" translate="flipto.account.Variation"></div>
                                    <div class="ft-label">Provide a bonus for warm leads</div>
                                </panel>
                                <panel class="intro" ft-targets-modal="audiences.wedding.storyriver.intro">
                                    <div class="ft-supertitle" translate="flipto.account.Intro"></div>
                                    <div class="ft-label" translate="flipto.account.StoryRiver"></div>
                                    <i class="ft-icn-play"></i>
                                </panel>
                            </secondary>
                        </ft-expandable-content>
                    </section>
                </div>
            </ft-section>

            <ft-section name="team">
                <div class="ft-view ft-segment-team">
                    <!--<section class="ft-section ft-synopsis-section">
                        <div class="ft-section-image"></div>
                        <div class="ft-container">
                            <div class="ft-section-image"></div>
                            <div class="ft-content">
                                Create deeply engaging experiences for your <span class="ft-persona-scheme-team">team</span>.
                                Let them give travelers an insider look at your hotel and be a local guide to your area.
                            </div>
                        </div>
                    </section>-->

                    <section class="ft-section">
                        <div class="ft-container">
                            <div class="ft-section-header">
                                <div class="ft-heading ft-text-plus-3">{{'flipto.account.ForYourTeamByYourTeam' | translate}}</div>
                            </div>
                        </div>
                        <ft-expandable-content class="ft-storytellers-expandable" [ngClass]="{'is-off': !photoAdvocacy?.isActive}">
                            <collapsed>
                                <div class="ft-heading ft-anim ft-text-plus-2">
                                    {{'flipto.account.DiscoverStoriesFromYourTeam' | translate}}
                                </div>
                                <div class="ft-summary ft-anim">
                                    {{'flipto.account.TeamBuildingAndManyMoreBenefits' | translate}}
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="!photoAdvocacy?.isActive">
                                    <p>
                                        <span class="ft-text-plus-1">{{'flipto.account.LearnMore' | translate }} <i class="ft-icn-arrow-right"></i></span>
                                    </p>
                                </div>

                                <div class="ft-snapshot ft-anim" *ngIf="photoAdvocacy?.isActive">
                                    <p>
                                        {{team?.photoContest?.contestCount | number}}
                                        <ng-pluralize count="team.photoContest.contestCount" when="{'one': 'campaign', 'other': 'campaigns'}" />,
                                        {{team?.photoContest?.finalistCount}}
                                        <ng-pluralize count="team.photoContest.finalistCount" when="{'one': 'storyteller', 'other': 'storytellers'}" />
                                    </p>
                                    <p>
                                        <span class="ft-count ft-text-plus-3">{{team?.photoContest?.reach | number}}</span>
                                        <span class="ft-text-plus-1">travelers reached</span>
                                    </p>
                                </div>
                                <div class="ft-panel-image-container">
                                    <div class="ft-perspective-container">
                                        <div class="ft-panel-image ft-screenshot ft-screen-storygallery">
                                            <div class="ft-browserchrome"></div>
                                            <div class="ft-browserviewport"></div>
                                            <div class="ft-panel-image-caption">
                                                <p>{{'flipto.account.SampleScreenshot' | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </collapsed>
                            <primary *ngIf="!photoAdvocacy?.isActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">
                                    {{'flipto.account.DiscoverStoriesFromYourTeam' | translate}}
                                </div>
                                <div class="ft-view-emptystate">
                                    <div class="ft-content ft-anim">
                                        <div class="ft-summary">
                                            <p>
                                                {{'flipto.account.LetYourTeamStoriesGiveAGlimpse' | translate}}
                                            </p>
                                            <p>
                                                {{'flipto.account.CreateACampaignForYourTeam' | translate}}
                                            </p>
                                            <div class="ft-alert">
                                                <div class="ft-alert-content">
                                                    <h3 class="ft-heading">{{'flipto.account.ThisFeatureIsOff' | translate}}.</h3>
                                                    <p>
                                                        {{'flipto.account.ContactYourAccountManagerToLaunchThisFeature' | translate}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="ft-panel intro" ft-targets-modal="audiences.team.storytellers.intro">
                                            <div class="ft-panel-bg"></div>
                                            <div class="ft-panel-content">
                                                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                                                <div class="ft-label">{{'flipto.account.TeamStorytellers' | translate}}</div>
                                                <i class="ft-icn-play"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </primary>
                            <primary *ngIf="photoAdvocacy?.isActive">
                                <div class="ft-heading ft-anim ft-text-plus-3">
                                    {{'flipto.account.DiscoverStoriesFromYourTeam' | translate}}
                                </div>
                                <div class="ft-content ft-anim">
                                    <ft-sections [registry]="[{name: 'current', title: 'Current', isActive: true, isDisabled: false}, {name: 'upcoming', title: 'Upcoming', isActive: false, isDisabled: false}, {name: 'past', title: 'Past', isActive: false, isDisabled: false}]">
                                        <div class="ft-view-emptystate" [hidden]="photoAdvocacyCampaigns?.contests?.item?.length">
                                            <div class="ft-summary">
                                                <p>
                                                    {{'flipto.account.GetYourTeamInvolvedToTellTheirStories' | translate}}
                                                </p>
                                            </div>
                                            <div class="ft-panel addnew" (click)="createNewContest(contestConstants.team)">
                                                <div class="ft-panel-bg"></div>
                                                <div class="ft-panel-content">
                                                    <i class="ft-icn-plus"></i> {{'flipto.account.CreateANewCampaign' | translate}}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="ft-view-contests-list">
                                            <!-- Contest ended -->
                                            <div class="ft-panel contest-panel current contest-active" *ngFor="let contest of (photoAdvocacyCampaigns?.contests?.item)"
                                                 (click)="showContest(contest, 'winners')">
                                                <div class="panel-image" [style.background-image]="'url(' + (getContestBackgroundImage(contest)) + ')'">
                                                    <div class="panel-matte"></div>
                                                </div>

                                                <div class="contest-display">
                                                    <div class="contest-display-content">
                                                        <div class="contest-title">{{contest.name}}</div>
                                                        <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
                                                        <div class="contest-status is-ended" [ngClass]="{'is-off': !(contest.isActive|parse:'bool')}">
                                                            <ft-contest-status [contest]="contest" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="contest-stats ft-v-align-container">
                                                    <div class="contest-stats-content ft-v-align-content">
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFinalists || 0) | number"
                                                                     [label]="'flipto.account.Storytellers' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalShares || 0) | number"
                                                                     [label]="'flipto.account.TotalShares' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFollowers || 0) | number"
                                                                     [label]="'flipto.account.FriendsReached' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalSignups || 0) | number"
                                                                     [label]="'flipto.account.WarmLeadsEarned' | translate | lowercase" />
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>

                                            <!-- Contest in progress -->
                                            <div class="ft-panel contest-panel current contest-active" *ngFor="let contest of (photoAdvocacyCampaigns?.contests?.item)"
                                                 (click)="showContest(contest, 'submissions')">
                                                <div class="panel-image" [style.background-image]="'url(' + (getContestBackgroundImage(contest)) + ')'">
                                                    <div class="panel-matte"></div>
                                                </div>

                                                <div class="contest-display ft-v-align-container">
                                                    <div class="contest-display-content ft-v-align-content">
                                                        <div class="contest-title" [innerHTML]="contest.name"></div>
                                                        <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
                                                        <div class="contest-status" *ngIf="!(contest.isActive|parse:'bool')"
                                                             [ngClass]="{'is-off': !(contest.isActive|parse:'bool')}">
                                                            <ft-contest-status [contest]="contest" />
                                                        </div>

                                                        <div class="ft-latest-stories" [hidden]="!(contest?.latestEntries?.item)">
                                                            <div class="contest-status is-latest">{{'flipto.account.LatestStories' | translate }}</div>
                                                            <div class="ft-content">
                                                                <div class="ft-story-slot"
                                                                     *ngFor="let latestEntry of (contest?.latestEntries?.item)"
                                                                     [style.background-image]="'url(' + azurePhoto(latestEntry, 'thumbnail') + ')'">
                                                                </div>
                                                                <!--<p *ngIf="((contest.totalPhotoSubmissions | parse:'number') - (contest.latestEntries | parse:'array').length) > 0">+{{(contest.totalPhotoSubmissions | parse:'number') - (contest.latestEntries | parse:'array').length}} more</p>-->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="contest-stats ft-v-align-container">
                                                    <div class="contest-stats-content ft-v-align-content">
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFinalists || 0) | number"
                                                                     [label]="'flipto.account.Storytellers' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalShares || 0) | number"
                                                                     [label]="'flipto.account.TotalShares' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalFollowers || 0) | number"
                                                                     [label]="'flipto.account.FriendsReached' | translate | lowercase" />
                                                        </p>
                                                        <p>
                                                            <ft-stat [value]="(contest.totalSignups || 0) | number"
                                                                     [label]="'flipto.account.WarmLeadsEarned' | translate | lowercase" />
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="ft-contest-tabs">
                                            View&nbsp;<ng-container *ngFor="let section of (ftSecsTop.registry)"><a *ngIf="section.name !== 'current'"
                                                         [ngClass]="{'active': section.isActive}" [ftSectionTrigger]="section.isActive ? 'current' : section.name">{{section.name}}&nbsp;campaigns</a></ng-container>
                                        </div>

                                        <ft-section name="upcoming">
                                            <ft-contests-list select="upcoming" [theme]="contestConstants.team" />
                                        </ft-section>

                                        <ft-section name="past">
                                            <ft-contests-list select="past" [theme]="contestConstants.team" />
                                        </ft-section>
                                    </ft-sections>
                                </div>
                            </primary>
                            <secondary>
                                <panel class="addnew" (click)="createNewContest(contestConstants.team)" [hidden]="!(photoAdvocacyCampaigns?.contests?.item?.length)">
                                    <div class="ft-label">
                                        <i class="ft-icn-plus"></i> <span translate="flipto.account.CreateANewCampaign"></span>
                                    </div>
                                </panel>
                                <panel class="variation" [hidden]="!(isTeamVariation)" (click)="showThemeCampaignDetails(contestConstants.team)">
                                    <div class="ft-supertitle" translate="flipto.account.Variation"></div>
                                    <div class="ft-label">Provide a bonus for your team</div>
                                </panel>
                                <!--<panel class="clarity">
                                    <div class="ft-supertitle">Clarity</div>
                                    <div class="ft-label">Value of team storytellers</div>
                                </panel>-->
                                <panel class="intro" ft-targets-modal="audiences.team.storytellers.intro">
                                    <div class="ft-supertitle" translate="flipto.account.Intro"></div>
                                    <div class="ft-label" translate="flipto.account.TeamStorytellers"></div>
                                    <i class="ft-icn-play"></i>
                                </panel>
                            </secondary>
                        </ft-expandable-content>
                    </section>
                </div>
            </ft-section>
        </ft-initialized-content>
    </section>
</ft-sections>

<ui-view />


<ft-modal id="audiences.guests.prestay.variation" template-type="v2" #mGuestsPrestayVariation>
    <div class="ft-modal ft-variations-modal">
        <div class="ft-modal-bg"></div>
        <button class="ft-btn-close" (click)="mGuestsPrestayVariation.cancel()"></button>
        <div class="ft-modal-container ft-v-align-container">
            <div class="ft-modal-content ft-v-align-content">
                <div class="ft-container">
                    <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                        Show your appreciation for guests who share.
                    </h1>
                    <div class="ft-summary">
                        {{'flipto.account.YourGuestsAndTheirFriendsCanEarnIncentives' | translate}} {{'flipto.account.OnlyTheFirstVariationBelowThatFitsYourGuestsProfile' | translate}} {{'flipto.account.DisplayingStatsFor' | translate}}
<!--                        <ft-snapshot on-date-range-changed="onCalendarDateRangeChange(start, end)" mode="conversational"></ft-snapshot>-->
                        <ft-daterange-picker (changed)="onCalendarDateRangeChange($event)" [darkMode]="true" [inlineMode]="true" [pastDays]="7" />
                    </div>

                    <ft-campaign-list [campaigns]="prestayCampaigns?.campaigns?.item" [sortMode]="prestayCampaignsSortMode" (campaignSelected)="showCampaignDetails('pre-stay', $event.id)" />

                    <a class="ft-btn ft-btn-outline-light ft-btn-plus-1 ft-btn-addnew" (click)="newCampaign('pre-stay')" [ngClass]="{'disabled': prestayCampaignsSortMode}">
                        <i class="ft-icn-plus"></i> {{'flipto.account.CreateANewVariation' | translate}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</ft-modal>

<ft-modal id="audiences.guests.storytellers.intro" template-type="v2" #mGuestsStorytellersIntro>
    <div class="ft-modal ft-intro-modal">
        <div class="ft-modal-bg"></div>
        <button class="ft-btn-close" (click)="mGuestsStorytellersIntro.cancel()"></button>
        <div class="ft-modal-container ft-v-align-container">
            <div class="ft-modal-content ft-v-align-content">
                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                    Storytellers
                </h1>
                <div class="ft-primary-video-section">
                    <div class="ft-video">
                        <div style="position:relative;padding-top:56.25%;">
                            <iframe src="https://stream.flip.to/turning-guests-into-storytellers/embed"
                                    style="border:none;position:absolute;top:0;left:0;height:100%;width:100%;"
                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ft-modal>

<ft-modal id="audiences.guests.prestay.intro" template-type="v2" #mGuestsPrestayIntro>
    <div class="ft-modal ft-intro-modal">
        <div class="ft-modal-bg"></div>
        <button class="ft-btn-close" (click)="mGuestsPrestayIntro.cancel()"></button>
        <div class="ft-modal-container ft-v-align-container">
            <div class="ft-modal-content ft-v-align-content">
                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                <div class="ft-modal-name ft-heading ft-text-plus-3">
                    {{'flipto.account.BuddingAdvocates' | translate}}
                </div>
                <div class="ft-primary-video-section">
                    <div class="ft-video">
                        <div style="position:relative;padding-top:56.25%;">
                            <iframe src="https://stream.flip.to/how-we-turn-guests-into-budding-advocates/embed"
                                    style="border:none;position:absolute;top:0;left:0;height:100%;width:100%;"
                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
                <div class="ft-secondary-video-section">
                    <div class="ft-video">
                        <div style="position:relative;padding-top:56.25%;">
                            <iframe src="https://stream.flip.to/changing-the-conversation-with-newly-booked-guests-confirmationx/embed"
                                    style="border:none;position:absolute;top:0;left:0;height:100%;width:100%;"
                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ft-modal>

<ft-modal id="audiences.visitors.storyriver.intro" template-type="v2" #mVisitorsStoryriverIntro>
    <div class="ft-modal ft-intro-modal">
        <div class="ft-modal-bg"></div>
        <button class="ft-btn-close" (click)="mVisitorsStoryriverIntro.cancel()"></button>
        <div class="ft-modal-container ft-v-align-container">
            <div class="ft-modal-content ft-v-align-content">
                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                    Story River
                </h1>
                <div class="ft-primary-video-section">
                    <div class="ft-video">
                        <div style="position:relative;padding-top:56.25%;">
                            <iframe src="https://stream.flip.to/introducing-photo-river-f0db3b/embed"
                                    style="border:none;position:absolute;top:0;left:0;height:100%;width:100%;"
                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ft-modal>

<ft-modal id="audiences.visitors.hpc.intro" template-type="v2" #mVisitorsHpcIntro>
    <div class="ft-modal ft-intro-modal">
        <div class="ft-modal-bg"></div>
        <button class="ft-btn-close" (click)="mVisitorsHpcIntro.cancel()"></button>
        <div class="ft-modal-container ft-v-align-container">
            <div class="ft-modal-content ft-v-align-content">
                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                    HPC
                </h1>
                <div class="ft-primary-video-section">
                    <div class="ft-video">
                    </div>
                </div>
            </div>
        </div>
    </div>
</ft-modal>

<ft-modal id="audiences.visitors.quoteslist.intro" template-type="v2" #mVisitorsQuoteslistIntro>
    <div class="ft-modal ft-intro-modal">
        <div class="ft-modal-bg"></div>
        <button class="ft-btn-close" (click)="mVisitorsQuoteslistIntro.cancel()"></button>
        <div class="ft-modal-container ft-v-align-container">
            <div class="ft-modal-content ft-v-align-content">
                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                    Quotes List
                </h1>
                <div class="ft-primary-video-section">
                    <div class="ft-video">
                    </div>
                </div>
            </div>
        </div>
    </div>
</ft-modal>

<ft-modal id="audiences.wedding.storytellers.intro" template-type="v2" #mWeddingStorytellersIntro>
    <div class="ft-modal ft-intro-modal">
        <div class="ft-modal-bg"></div>
        <button class="ft-btn-close" (click)="mWeddingStorytellersIntro.cancel()"></button>
        <div class="ft-modal-container ft-v-align-container">
            <div class="ft-modal-content ft-v-align-content">
                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                    {{'flipto.account.WeddingStorytellers' | translate}}
                </h1>
                <div class="ft-primary-video-section">
                    <div class="ft-video">
                        <div style="position:relative;padding-top:56.25%;">
                            <iframe src="https://stream.flip.to/turning-guests-into-storytellers/embed"
                                    style="border:none;position:absolute;top:0;left:0;height:100%;width:100%;"
                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ft-modal>

<ft-modal id="audiences.wedding.storyriver.intro" template-type="v2" #mWeddingStoryriverIntro>
    <div class="ft-modal ft-intro-modal">
        <div class="ft-modal-bg"></div>
        <button class="ft-btn-close" (click)="mWeddingStoryriverIntro.cancel()"></button>
        <div class="ft-modal-container ft-v-align-container">
            <div class="ft-modal-content ft-v-align-content">
                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                    Story River
                </h1>
                <div class="ft-primary-video-section">
                    <div class="ft-video">
                        <div style="position:relative;padding-top:56.25%;">
                            <iframe src="https://stream.flip.to/introducing-photo-river-f0db3b/embed"
                                    style="border:none;position:absolute;top:0;left:0;height:100%;width:100%;"
                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ft-modal>

<ft-modal id="audiences.team.storytellers.intro" template-type="v2" #mTeamStorytellersIntro>
    <div class="ft-modal ft-intro-modal">
        <div class="ft-modal-bg"></div>
        <button class="ft-btn-close" (click)="mTeamStorytellersIntro.cancel()"></button>
        <div class="ft-modal-container ft-v-align-container">
            <div class="ft-modal-content ft-v-align-content">
                <div class="ft-supertitle">{{'flipto.account.Intro' | translate}}</div>
                <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                    {{'flipto.account.TeamStorytellers' | translate}}
                </h1>
                <div class="ft-primary-video-section">
                    <div class="ft-video">
                        <div style="position:relative;padding-top:56.25%;">
                            <iframe src="https://stream.flip.to/introducing-photo-river-f0db3b/embed"
                                    style="border:none;position:absolute;top:0;left:0;height:100%;width:100%;"
                                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ft-modal>

<ft-modal id="audiences.guests.poststay.clarity" template-type="v2" #mGuestsPoststayClarity>
    <div class="ft-modal ft-clarity-modal">
        <header class="ft-header">
            <button class="ft-btn-close" (click)="mGuestsPoststayClarity.cancel()"></button>
            <div class="ft-bg-image"></div>
            <div class="ft-bg-matte"></div>
            <div class="ft-container ft-v-align-container">
                <div class="ft-content ft-v-align-content">
                    <div class="ft-supertitle">Clarity</div>
                    <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                        The value of storytellers
                    </h1>
                </div>
            </div>
        </header>
        <main class="ft-main">

        </main>
    </div>
</ft-modal>

<ft-modal id="audiences.guests.prestay.clarity" template-type="v2" #mGuestsPrestayClarity>
    <div class="ft-modal ft-clarity-modal">
        <header class="ft-header">
            <button class="ft-btn-close" (click)="mGuestsPrestayClarity.cancel()"></button>
            <div class="ft-v-align-container">
                <div class="ft-v-align-content">
                    <div class="ft-content">
                        <div class="ft-supertitle">{{'flipto.account.Clarity' | translate}}</div>
                        <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                            {{'flipto.account.TheValueOfBuddingAdvocates' | translate}}
                        </h1>
                    </div>
                </div>
            </div>
        </header>
        <main class="ft-main">

        </main>
    </div>
</ft-modal>

<ft-modal id="audiences.visitors.storyriver.clarity" template-type="v2" #mVisitorsStoryriverClarity>
    <div class="ft-modal ft-clarity-modal">
        <header class="ft-header">
            <button class="ft-btn-close" (click)="mVisitorsStoryriverClarity.cancel()"></button>
            <div class="ft-bg-image"></div>
            <div class="ft-bg-matte"></div>
            <div class="ft-container ft-v-align-container">
                <div class="ft-content ft-v-align-content">
                    <div class="ft-supertitle">{{'flipto.account.Clarity' | translate}}</div>
                    <h1 class="ft-modal-name ft-heading ft-text-plus-3">
                        The impact of Story River
                    </h1>
                </div>
            </div>
        </header>
        <main class="ft-main">

        </main>
    </div>
</ft-modal>
